import React from 'react';
import { TreeSelect as _T } from 'antd';

const TreeSelect = (props) => {
  return <_T {...props} />;
};

export { TreeSelect };
